import { bindActionCreators, compose } from 'redux';
import partial from 'lodash/partial';
import { connect, set as setUI, featureOn, makeScrollable } from '@instructure/quiz-core';
import { BUILD_TRAY_OPEN, BUILD_TRAY_BUTTON_REF } from '@instructure/quiz-common';
import { BaseHeader as BaseHeaderPresenter } from './presenter';
function mapStateToProps(state) {
  return {
    contextUuid: state.getIn(['outcomes', 'contextUuid']),
    outcomesEndpoint: state.getIn(['outcomes', 'outcomesEndpoint']),
    outcomesToken: state.getIn(['outcomes', 'outcomesToken']),
    outcomeAlignmentsOn: featureOn('outcome_alignments')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onItemBanksClick: bindActionCreators(setUI.bind(void 0, BUILD_TRAY_OPEN, true), dispatch),
    itemBanksButtonRef: bindActionCreators(partial(setUI, BUILD_TRAY_BUTTON_REF), dispatch)
  };
}
export var BaseHeader = compose(connect(mapStateToProps, mapDispatchToProps), makeScrollable)(BaseHeaderPresenter);
export default BaseHeader;